export default {"src":"/_next/static/media/private-cloud.230098dd.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};